import Cookies from 'js-cookie';

import { useQuery } from 'react-query';

import { useFeaturesFlagState } from '@/features/featuresFlag/hooks';
import { axiosWithoutInterceptors } from '@/lib/axios';

import { FEATURES_FLAG_KEYS } from './featureFlag.keys';

export const getFeatureFlagAsync = ({ featureFlagKey }: { featureFlagKey: string }) =>
  axiosWithoutInterceptors.get<{ isEnabled: boolean }>(`/feature-flags/${featureFlagKey}`);

export const useGetFeatureFlagAsync = ({ featureFlagKey }: { featureFlagKey: string }) =>
  useQuery({
    cacheTime: 0,
    queryKey: ['feature-flag', featureFlagKey],
    queryFn: async () => {
      const { data } = await getFeatureFlagAsync({ featureFlagKey });
      return data.isEnabled;
    },
    onSuccess: (data) => {
      useFeaturesFlagState.getState().featuresFlag.set(featureFlagKey, data);

      if (featureFlagKey === FEATURES_FLAG_KEYS.SHERPASS && data) {
        Cookies.remove('authToken');
      }
    },
  });
